/**
 * @file MIME 类型解析
 * @author Yangholmes 2024-01-25
 */

import filetype from 'magic-bytes.js'

/**
 * 解析文件的 MIME 信息
 * @param file 文件
 * @returns
 */
export function parseMimeType(file: File) {
  return new Promise<ReturnType<typeof filetype>>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = async(e) => {
          const buffer = e.target?.result;
          // const header = new Uint8Array(buffer as ArrayBuffer, 0, 4);
          resolve(filetype(new Uint8Array(buffer as ArrayBuffer)))
        };
        reader.onerror = reject;
        reader.readAsArrayBuffer(file)
    });
}
